import { dialogsApi } from '../../api';

export const SET_CURRENT_DIALOG_ID = 'SET_CURRENT_DIALOG_ID';
export const SET_RECENT_DIALOG_ID_AS_CURRENT = 'SET_RECENT_DIALOG_ID_AS_CURRENT';
export const SET_DIALOGS = 'DIALOGS:SET_DIALOGS';
export const SET_DIALOG_STATUS_CHANGED = 'DIALOGS:SET_DIALOG_STATUS_CHANGED';
export const SET_UNREAD_COUNT = 'DIALOGS:SET_UNREAD_COUNT';
export const RESET_DIALOG_STATUS_CHANGE = 'DIALOGS:RESET_DIALOG_STATUS_CHANGE';
export const SET_ARCHIVE_DIALOG = 'DIALOGS:SET_ARCHIVE_DIALOG';

const actions = {
    setCurrentDialogId: (dialogId) => ({
        type: SET_CURRENT_DIALOG_ID,
        payload: dialogId
    }),
    setDialogs: {
        handle: SET_DIALOGS,
        event: 'dialogs',
    },
    setIsArchiveCurrentDialog: (isArchive) => ({
        type: SET_ARCHIVE_DIALOG,
        payload: isArchive
    }),
    setUnreadCount: {
        handle: SET_UNREAD_COUNT,
        event: 'dialogsCount',
    },
    getDialogs: () => (dispatch) => {
        dispatch(actions.setDialogs);
        dispatch(actions.setUnreadCount);
        dialogsApi.getDialogs();
        dialogsApi.fetchDialogsCount();
    },
    setRecentDialogIdAsCurrent: {
        handle: SET_RECENT_DIALOG_ID_AS_CURRENT,
        event: 'recentDialog',
    },
    setDialogStatusChanged: {
        handle: SET_DIALOG_STATUS_CHANGED,
        event: 'expert.changed',
    },
    setDialogStatus: (status) => ({
        type: RESET_DIALOG_STATUS_CHANGE,
        payload: status
    }),
    listDialogStatusChanged: () => (dispatch) => {
        dispatch(actions.setDialogStatusChanged);
    },
    listenRecentDialog: () => (dispatch) => {
        dispatch(actions.setRecentDialogIdAsCurrent);
    },
    listenUnreadCount: () => (dispatch) => {
        dispatch(actions.setUnreadCount);
        dialogsApi.fetchDialogsCount();
    },
    findNewExpert: () => (dispatch) => {
        dispatch(actions.setRecentDialogIdAsCurrent);
        dialogsApi.findNewExpert();
    }
};

export default actions;